import React, { useEffect } from "react";
import { InstallationProvider, useConnection } from "@amp-labs/react";

export interface IntegrationStatus {
  isConnected: boolean;
  isLoading: boolean;
  isError: boolean;
}

interface AmpersandConnectionStatusProps {
  integrationId: string;
  groupRef: string;
  consumerRef: string;
  onStatus: (integrationId: string, status: IntegrationStatus) => void;
}

const ConnectionStatusReporter: React.FC<
  Pick<AmpersandConnectionStatusProps, "integrationId" | "onStatus">
> = ({ integrationId, onStatus }) => {
  const { connection, isPending, isError } = useConnection();

  useEffect(() => {
    onStatus(integrationId, {
      isConnected: !!connection,
      isLoading: isPending && !isError,
      isError
    });
  }, [integrationId, connection, isPending, isError, onStatus]);

  return null;
};

// Ampersand exposes connection state only through a hook scoped to an
// InstallationProvider, so each Ampersand integration mounts one of these to
// report its state to the page.
const AmpersandConnectionStatus: React.FC<AmpersandConnectionStatusProps> = ({
  integrationId,
  groupRef,
  consumerRef,
  onStatus
}) => (
  <InstallationProvider
    integration={integrationId}
    groupRef={groupRef}
    consumerRef={consumerRef}
  >
    <ConnectionStatusReporter integrationId={integrationId} onStatus={onStatus} />
  </InstallationProvider>
);

export default AmpersandConnectionStatus;
